import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LocationService from "../../../services/LocationService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListLocation from "../Components/ListLocation";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewLocation() {
  const [locations, setLocations] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const fetchLocations = async () => {
    setLoading(true);
    try {
      const res = await LocationService.getAll(currentPage, itemsPerPage, searchText);
      setLocations(res.data || []);
      setPageCount(res.totalPages || 0);
    } catch (err) {
      console.error(err);
      showMessage("Error loading locations", "error");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchLocations();
  }, [currentPage, searchText]);


  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => {
    navigate("/cpnl/location/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one location to modify.");
      return;
    }
    navigate(`/cpnl/location/add/${selected}`);
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure you want to change status to ${newStatus}?`))
      return;

    try {
      const res = await LocationService.updateStatus(id, newStatus);
      const updatedStatus = res?.newStatus || res?.data?.newStatus || newStatus;
      setLocations((prev) =>
        prev.map((loc) =>
          loc.id === id ? { ...loc, status: updatedStatus } : loc
        )
      );
      showMessage(res?.message || `Location status updated to ${updatedStatus}`, "success");
    } catch (error) {
      console.error(error);
      const errMsg = error?.response?.data?.message || error?.message || "Failed to update status";
      showMessage(errMsg, "error");
    }
  };

  //  SEARCH FILTER
  // const filteredLocations = locations.filter(
  //   (l) =>
  //     l.locationName.toLowerCase().includes(searchText.toLowerCase()) ||
  //     l.locationCode.toLowerCase().includes(searchText.toLowerCase())
  // );

  const filteredLocations = locations;

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";

  return (
    <>
      <Breadcrumb pageTitle="Locations" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}

          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />


          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Location"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/* 🔹 TABLE */}
          <ListLocation
            loading={loading}
            filteredLocations={filteredLocations}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            getStatusClass={getStatusClass}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
